import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0553b99b&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0553b99b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553b99b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0553b99b')) {
      api.createRecord('0553b99b', component.options)
    } else {
      api.reload('0553b99b', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0553b99b&scoped=true&", function () {
      api.rerender('0553b99b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5dtU1ZP57HR/JS/comp/PopupDialog.vue"
export default component.exports